/**
 * The records a draft's paragraph rests on, as chips at its end (WS-22):
 * each by its number on the case, its statement on hover, opening beside
 * the view — the open record's chip filled.
 */

import { recordName, useRecordIndex } from './recordIndex';
import classes from './Workbench.module.css';

export function RecordChips({ ids }: Readonly<{ ids: string[] }>) {
  const records = useRecordIndex();
  const open = records.openId?.toLowerCase() ?? null;
  const entries = ids.flatMap((id) => {
    const entry = records.entry(id);
    return entry ? [entry] : [];
  });
  if (entries.length === 0) {
    return null;
  }
  return (
    <span className={classes.chips} data-testid="record-chips">
      {entries.map((entry) => (
        <button
          key={entry.id}
          type="button"
          className={classes.chip}
          title={entry.statement}
          aria-pressed={open === entry.id.toLowerCase()}
          onClick={(event) => {
            event.stopPropagation();
            records.open?.(entry.id);
          }}
          data-testid={`cite-${entry.id}`}
        >
          {recordName(entry)}
        </button>
      ))}
    </span>
  );
}
